import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';

import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';

import { BarrioContext } from '../components/BarrioContext';
import { useAuth } from '../components/AuthContext';
import { getMailTemplates, saveMailTemplate } from '../service/MailTemplateService';
import MailTemplateEditor from '../components/MailTemplateEditor';

const TIPOS_MAIL = [
    { label: 'Nuevo Gasto', value: 'NuevoGasto' },
    { label: 'Envío por Mail', value: 'EnvioMail' },
    { label: 'Nueva Infracción', value: 'NuevaInfraccion' },
];

const ConfiguracionMails = () => {
    const toast = useRef(null);
    const { barrio } = useContext(BarrioContext);
    const { administracionId } = useAuth();

    const [tipoMail, setTipoMail] = useState('NuevoGasto');
    const [templates, setTemplates] = useState({});
    const [asunto, setAsunto] = useState('');
    const [htmlTemplate, setHtmlTemplate] = useState('');
    const [esDefault, setEsDefault] = useState(false);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    const fetchTemplates = useCallback(async () => {
        if (!barrio?.id) return;
        setLoading(true);
        try {
            const response = await getMailTemplates(administracionId, barrio.id);
            const map = {};
            response.data.forEach((t) => { map[t.tipoMail] = t; });
            setTemplates(map);
        } catch (err) {
            console.error(err);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo obtener la configuración de mails', life: 3000 });
        } finally {
            setLoading(false);
        }
    }, [administracionId, barrio?.id]);

    useEffect(() => { fetchTemplates(); }, [fetchTemplates]);

    useEffect(() => {
        const actual = templates[tipoMail];
        if (actual) {
            setAsunto(actual.asunto || '');
            setHtmlTemplate(actual.htmlTemplate || '');
            setEsDefault(!!actual.esDefault);
        }
    }, [tipoMail, templates]);

    const handleGuardar = async () => {
        if (!barrio?.id) return;
        setSaving(true);
        try {
            await saveMailTemplate({
                administracionId,
                barrioId: barrio.id,
                tipoMail,
                asunto,
                htmlTemplate,
            });
            toast.current.show({ severity: 'success', summary: 'Guardado', detail: 'La configuración de mail se guardó correctamente', life: 3000 });
            fetchTemplates();
        } catch (err) {
            console.error(err);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo guardar la configuración de mail', life: 3000 });
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <h4>Configuración de Mails</h4>
            <br />

            <Toast ref={toast} />
            <Dialog visible={loading} modal closable={false} showHeader={false} className="backdrop-dialog">
                <ProgressSpinner style={{ width: '60px', height: '60px' }} />
            </Dialog>

            <div className="grid">
                <div className="col-12 md:col-4 mb-3">
                    <label>Evento</label>
                    <Dropdown
                        value={tipoMail}
                        options={TIPOS_MAIL}
                        onChange={(e) => setTipoMail(e.value)}
                        className="w-full"
                    />
                </div>
            </div>

            <MailTemplateEditor
                tipoMail={tipoMail}
                asunto={asunto}
                onChangeAsunto={setAsunto}
                htmlTemplate={htmlTemplate}
                onChangeHtml={setHtmlTemplate}
                barrioNombre={barrio?.nombre}
                esDefault={esDefault}
                onError={(msg) => toast.current.show({ severity: 'error', summary: 'Error', detail: msg, life: 3000 })}
            />

            <Button label="Guardar" icon="pi pi-save" onClick={handleGuardar} loading={saving} disabled={!barrio?.id} />
        </>
    );
};

export default ConfiguracionMails;
